module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"mobile_offer":{"title":"Создайте свой профиль!","text":"Войдите на Aromo, чтобы получить доступ ко всем функциям сайта и найти коллег по увлечению.","button":"Войти"}}}')
  delete Component.options._Ctor
}
